'use client';

import React from 'react';
import Header from '@/components/common/Header';
import Footer from '@/app/home-page/components/Footer';
import MissionSection from './components/MissionSection';
import ValuePillars from './components/ValuePillars';
import Icon from '@/components/ui/AppIcon';
import Link from 'next/link';

const AboutPage = () => {
    return (
        <main className="min-h-screen bg-background">
            <Header />

            {/* Hero Section */}
            <section className="relative pt-32 pb-20 bg-primary overflow-hidden">
                <div className="absolute inset-0 opacity-10">
                    <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-accent rounded-full blur-[120px] -translate-y-1/2 translate-x-1/2" />
                    <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-secondary rounded-full blur-[120px] translate-y-1/2 -translate-x-1/2" />
                </div>

                <div className="relative mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-8 text-center">
                    <h1 className="font-heading text-5xl sm:text-6xl md:text-7xl font-bold text-white mb-6 tracking-tight">
                        About the <span className="text-accent underline decoration-accent/30 underline-offset-8">Project</span>
                    </h1>
                    <p className="font-body text-xl text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
                        Bridging the gap between premium car owners and the the nation's most talented independent mechanics.
                    </p>
                    <div className="flex flex-wrap justify-center gap-4">
                        <Link
                            href="/search-results"
                            className="px-8 py-4 bg-white text-primary rounded-xl font-heading font-bold shadow-elevation-lg transition-smooth hover:bg-white/90 active:scale-95 flex items-center space-x-2"
                        >
                            <span>Find a Mechanic</span>
                            <Icon name="ArrowRightIcon" size={20} />
                        </Link>
                        <Link
                            href="#mission"
                            className="px-8 py-4 bg-primary-foreground/10 text-white border border-white/20 rounded-xl font-heading font-bold transition-smooth hover:bg-white/10 active:scale-95"
                        >
                            Our Mission
                        </Link>
                    </div>
                </div>
            </section>

            <div id="mission">
                <MissionSection />
            </div>

            <ValuePillars />

            {/* CTA Section */}
            <section className="py-24 bg-background">
                <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-8">
                    <div className="bg-primary rounded-[2rem] p-12 sm:p-20 relative overflow-hidden text-center sm:text-left">
                        <div className="absolute top-0 right-0 w-64 h-64 bg-accent/20 rounded-full blur-3xl" />
                        <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-12">
                            <div className="max-w-xl">
                                <h2 className="font-heading text-4xl sm:text-5xl font-bold text-white mb-6">
                                    Ready to experience better car care?
                                </h2>
                                <p className="font-body text-lg text-white/70 mb-0">
                                    Join thousands of drivers nationwide who have found their trusted mechanic through our platform.
                                </p>
                            </div>
                            <div className="flex-shrink-0">
                                <Link
                                    href="/signup"
                                    className="px-10 py-5 bg-accent text-accent-foreground rounded-2xl font-heading text-lg font-bold shadow-elevation-xl transition-smooth hover:scale-105 active:scale-95 block sm:inline-block"
                                >
                                    Get Started Today
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </main>
    );
};

export default AboutPage;
